import BaseModelFactory from './base.factory'
import UserEopolicyService from './../services/UserEopolicy.service'
import UserEopolicy from './../models/user-eopolicy.model'

class UserEopolicyFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: UserEopolicyService, Model: UserEopolicy })
  static findById = async id => await this._findBy({ id: id }, { Service: UserEopolicyService, Model: UserEopolicy })
  static findByUserId = async id =>
    await this._findBy({ user_id: id }, { Service: UserEopolicyService, Model: UserEopolicy })
  static findAllByUserId = async id =>
    await this._findAllBy({ user_id: id }, { Service: UserEopolicyService, Model: UserEopolicy })
  static create = payload =>
    this._create(payload, {
      Service: UserEopolicyService,
      Model: UserEopolicy,
    })
}

export default UserEopolicyFactory
